import { useProperty, useTranslation } from '@eti/providers';
import { analytics } from '@eti/utils';
import { useDidUpdateEffect } from '../../custom-hooks/useDidUpdateEffect';
import { getPriceProps, getReadMoreLabel, getSingleChoiceProps } from '../../common/utils/productCardProps';
import { SEAT_MAP } from '../../products';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { getMinPrice } from '../utils/selection';
import SeatMapCardChangeSelection from './SeatMapCardChangeSelection';
import { jsx as _jsx } from "react/jsx-runtime";
const SeatMapProduct = _ref => {
  let {
    form,
    setIsSeatMapModalOpen,
    isSeatMapSelected,
    priceRaw,
    bounds
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const readMoreContent = t('seatMapReadMoreContent');
  const additionalInformation = t('seatMapAdditionalInformation');
  const description = t('seatMapDescription');
  const title = t('seatMapTitle');
  const extraProps = {
    ...getSingleChoiceProps(t, p, nonDebugT),
    onButtonChange: value => {
      if (value === 'true') {
        setIsSeatMapModalOpen(true);
        analytics.pushToDataLayer({
          event: 'seatingVisible',
          seatingOnPage: value === 'true' ? 'YES' : 'NO'
        });
      }
    }
  };
  const illustrationUrl = useIllustration(SEAT_MAP.name);
  const productPrice = isSeatMapSelected ? priceRaw : getMinPrice(bounds);
  const productOptions = {
    priceRaw: productPrice
  };
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSeatMapSelected, productOptions);
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    additionalInformation,
    description,
    extraProps,
    form,
    illustrationUrl,
    isSelected: isSeatMapSelected,
    price,
    priceLabel,
    priceRaw: productPrice,
    priceSuffix,
    productId: SEAT_MAP.id,
    productName: SEAT_MAP.name,
    readMoreButtonLabel,
    readMoreContent,
    title,
    shouldDisplayUpsell: false
  };
  useDidUpdateEffect(() => {
    let timeoutId;
    if (!isSeatMapSelected) {
      timeoutId = setTimeout(() => {
        var _document$querySelect;
        (_document$querySelect = document.querySelector('#seatMap_false')) === null || _document$querySelect === void 0 || _document$querySelect.focus();
      }, 300);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isSeatMapSelected]);
  const onChangeSelection = () => {
    setIsSeatMapModalOpen(true);
  };
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: productData,
    children: isSeatMapSelected && /*#__PURE__*/_jsx(SeatMapCardChangeSelection, {
      onClick: onChangeSelection
    })
  });
};
export default SeatMapProduct;
//# sourceMappingURL=SeatMapProductCard.js.map